import React from "react";
import styled from "styled-components";
import timeSplitter from "src/utils/time-splitter";
import { Stack } from "@mui/material";
import { intlNumberFormatter } from "src/utils/number-formatter";
import SlopeBadge from "src/scenes/overview/overview-components/slope-badge";

const LargeNumber = styled.p`
    font-size: 44px;
    font-weight: bold;
    line-height: 1;
    margin: 0;
`;

const BreakdownNumber = styled.p`
    font-size: 14px;
    font-weight: bolder;
    line-height: 1;
    margin: 0;
`;

const HelperText = styled.p`
    font-size: 12px;
    font-weight: 300;
    line-height: 1;
    margin: 3px;
`;

const executiveValueFormatter = (value, type, isBreakdown, customText, slope) => {
    if (!type && isBreakdown) return <BreakdownNumber>{value}</BreakdownNumber>;
    if (!type && !isBreakdown) return <LargeNumber>{value}</LargeNumber>;
    if (type === "percentile") {
        if (isBreakdown) {
            return (
                <Stack direction="row" alignItems="center">
                    <BreakdownNumber>{Math.round(value * 100)}</BreakdownNumber>
                    <HelperText>
                        %{customText && ` `}
                        {customText}
                    </HelperText>
                </Stack>
            );
        }
        return (
            <Stack direction="column" alignItems="flex-start">
                <Stack direction="row" alignItems="center">
                    <LargeNumber>{Math.round(value * 100)}</LargeNumber>
                    <SlopeBadge slope={slope} />
                </Stack>
                <HelperText>
                    %{customText && ` `}
                    {customText}
                </HelperText>
            </Stack>
        );
    }
    if (type === "time") {
        if (isBreakdown) {
            return (
                <Stack direction="row" alignItems="center">
                    <BreakdownNumber>{timeSplitter(value, "variable-accuracy")}</BreakdownNumber>
                    <HelperText>
                        {timeSplitter(value, "text")}
                        {customText && ` `}
                        {customText}
                    </HelperText>
                </Stack>
            );
        }
        return (
            <Stack direction="column" alignItems="flex-start">
                <Stack direction="row" alignItems="center">
                    <LargeNumber>{timeSplitter(value, "variable-accuracy")}</LargeNumber>
                    <SlopeBadge slope={slope} />
                </Stack>
                <HelperText>
                    {timeSplitter(value, "text")}
                    {customText && ` `}
                    {customText}
                </HelperText>
            </Stack>
        );
    }
    if (type === "custom") {
        if (isBreakdown) {
            return (
                <Stack direction="row" alignItems="center">
                    <BreakdownNumber>{value}</BreakdownNumber>
                    <HelperText>{customText}</HelperText>
                </Stack>
            );
        }
        return (
            <Stack direction="column" alignItems="flex-start">
                <Stack direction="row" alignItems="center">
                    <LargeNumber>{value}</LargeNumber>
                    <SlopeBadge slope={slope} />
                </Stack>
                <HelperText>{customText}</HelperText>
            </Stack>
        );
    }
    if (type === "number") {
        if (isBreakdown) {
            return (
                <Stack direction="row" alignItems="center">
                    <BreakdownNumber>{intlNumberFormatter(value)}</BreakdownNumber>
                    <HelperText>{customText}</HelperText>
                </Stack>
            );
        }
        return (
            <Stack direction="column" alignItems="flex-start">
                <Stack direction="row" alignItems="center">
                    <LargeNumber>{intlNumberFormatter(value)}</LargeNumber>
                    <SlopeBadge slope={slope} />
                </Stack>
                <HelperText>{customText}</HelperText>
            </Stack>
        );
    }
    return null;
};

export const ExecutiveValueFormatterComponent = ({
    value,
    type,
    isBreakdown,
    customText,
    slope,
}) => {
    return executiveValueFormatter(value, type, isBreakdown, customText, slope);
};

export default executiveValueFormatter;
